type PricedFeature = {
  cost: number;
  fakeCost: number;
  fiatCost?: number;
  fiatFakeCost?: number;
  currencySign: string;
  telegramStarsAmount?: number;
};

export type FeaturePriceBreakdown = {
  coinsAmount: number;
  fiatAmount: number;
  fiatFakeAmount: number;
  telegramStarsAmount: number;
  currencySign: string;
};

export type FeatureDisplayPrice = {
  cost: number;
  fakeCost: number;
  currencySign: string;
};

export const getFeatureDisplayPrice = (feature: PricedFeature, isTelegramMiniApp: boolean): FeatureDisplayPrice => {
  if (isTelegramMiniApp && typeof feature.telegramStarsAmount === 'number') {
    return {
      cost: feature.telegramStarsAmount,
      fakeCost: feature.telegramStarsAmount,
      currencySign: '⭐',
    };
  }

  return {
    cost: feature.cost,
    fakeCost: feature.fakeCost,
    currencySign: feature.currencySign,
  };
};

export const getFeaturePriceBreakdown = (feature: PricedFeature): FeaturePriceBreakdown => ({
  coinsAmount: feature.cost,
  fiatAmount: feature.fiatCost ?? feature.cost,
  fiatFakeAmount: feature.fiatFakeCost ?? feature.fakeCost,
  telegramStarsAmount: feature.telegramStarsAmount ?? 0,
  currencySign: feature.currencySign,
});
